import { useState } from 'react';
import type {
  DonViTinh,
  GiaBanKhachHangData,
  GiaBanNhomKhachHangData,
  GiaBanV2,
  GiaBanVatTuData,
  NgoaiTe
} from '@/types/schemas';

export const useSearchFieldStates = (initialData?: GiaBanV2 | null) => {
  const [vatTu, setVatTu] = useState<GiaBanVatTuData | null>(
    initialData?.ma_vt_data || initialData?.vat_tu_data || null
  );

  const [donViTinh, setDonViTinh] = useState<DonViTinh | null>(initialData?.dvt_data || null);

  const [ngoaiTe, setNgoaiTe] = useState<NgoaiTe | null>(initialData?.ma_nt_data || null);

  const [khachHang, setKhachHang] = useState<GiaBanKhachHangData | null>(initialData?.ma_kh_data || null);

  const [nhomKhachHang1, setNhomKhachHang1] = useState<GiaBanNhomKhachHangData | null>(
    initialData?.nh_kh1_data || null
  );
  const [nhomKhachHang2, setNhomKhachHang2] = useState<GiaBanNhomKhachHangData | null>(
    initialData?.nh_kh2_data || null
  );
  const [nhomKhachHang3, setNhomKhachHang3] = useState<GiaBanNhomKhachHangData | null>(
    initialData?.nh_kh3_data || null
  );

  return {
    vatTu,
    setVatTu,
    donViTinh,
    setDonViTinh,
    ngoaiTe,
    setNgoaiTe,
    khachHang,
    setKhachHang,
    nhomKhachHang1,
    setNhomKhachHang1,
    nhomKhachHang2,
    setNhomKhachHang2,
    nhomKhachHang3,
    setNhomKhachHang3
  };
};
